import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from '../../directives/button.directive';

@Component({
  selector: 'nk-page-not-found-view',
  imports: [RouterModule, TranslateModule, ButtonDirective],
  templateUrl: 'page-not-found-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundViewComponent implements OnInit {
  public title = signal<string>(extractTranslation('route.not_found.title'));
  public message = signal<string>(extractTranslation('route.not_found.message'));
  private _activatedRoute = inject(ActivatedRoute);

  public ngOnInit(): void {
    this.title.set(this._activatedRoute.snapshot.queryParams['title']);
    this.message.set(this._activatedRoute.snapshot.queryParams['message']);
  }
}
